<template>
  <div class="forum-detail">
    <!-- 面包屑导航 -->
    <div class="linkbanner">
      <el-link style="font-size: 3rem" type="danger" @click="index" >首页</el-link>
      <el-icon><ArrowRight /></el-icon>
      <el-link style="font-size: 3rem" type="danger" @click="next" >论坛</el-link>
      <el-icon><ArrowRight /></el-icon>
      <el-link style="font-size: 3rem" type="info" >{{ postDetail.title }}</el-link>
    </div>
    <!-- 帖子详情 -->
    <div class="wrap post-detail">
      <div class="post-header">
        <h1>{{ postDetail.title }}</h1>
        <div class="post-info">
          <span>作者：{{ postDetail.authorName }}</span>
          <span>发布时间：{{ postDetail.createTime }}</span>
          <span>浏览量：{{ postDetail.viewCount }}</span>
          <span>评论数：{{ postDetail.commentCount }}</span>
        </div>
      </div>

      <div class="post-content">
        <div v-html="postDetail.content"></div>
      </div>
    </div>
    <!-- 评论区 -->
    <div class="wrap comment-area">
      <h3 style="font-size: 3rem">评论区</h3>

      <!-- 评论输入框 -->
      <div class="comment-input" style="margin-top: 1rem">
        <div>
          <el-input
              type="textarea"
              placeholder="写下你的评论..."
              v-model="commentContent"
              :rows="4"
          ></el-input>
        </div>
        <el-button
            type="primary"
            size="medium"
            style="margin-top: 1rem; margin-left: auto; display: block;"
            :style="{backgroundColor: '#F32835',borderColor: '#F32835',}"
            @click="submitComment"
        >
          提交评论
        </el-button>
      </div>

      <!-- 评论列表 -->
      <div class="comment-list" v-if="commentList.length > 0" style="margin-top: 1rem;">
        <div class="comment-item" v-for="comment in commentList" :key="comment.id"
             style="display: flex; padding: 1.5rem; margin-bottom: 1.5rem; background: #fff; border-radius: 8px;
              box-shadow: 0 0 0.2rem rgba(0,0,0,0.5);"
        >
          <div class="comment-avatar" style="margin-right: 1rem;">
            <img
                :src="defaultAvatar"
                style="width: 4.5rem; height: 4.5rem; border-radius: 50%; object-fit: cover;"
            >
          </div>
          <div class="comment-main" style="display: flex; flex-direction: column; gap: 0.8rem;width: 100%;">
            <!-- 用户姓名 -->
            <div class="comment-header">
              <div class="comment-author" style="font-weight: 300; font-size: 1.3rem; color: #393838;">
                {{ comment.authorName }}
              </div>
            </div>
            <!-- 评论内容（会显示在姓名下方） -->
            <div class="comment-content" style="font-size: 1.4rem; line-height: 1.6; color: #333;">
              {{ comment.content }}
            </div>
            <div class="comment-content" style="color: #393838;display: flex">
              <div style="font-size: 1.1rem;">{{comment.createTime}}</div>
              <button
                  @click="showReplyInput(comment.id)"
                  style="border: none; background: none; padding: 0; margin: 0 0 0 1rem;font-size: 1.1rem; color: #393838; cursor: pointer; transition: color 0.2s;"
                  onmouseover="this.style.color='#1890ff'"
                  onmouseout="this.style.color='#393838'"
              >
              回复
              </button>
            </div>
            <div class="comment-content" style="line-height: 1.6; color: #393838;display: flex" v-if="comment.replyCount > 0 && !comment.showCommentReply">
              <button
                  @click="getReplyList(comment.id)"
                  style="border: none; background: none; padding: 0; margin: 0;font-size: 1.1rem; color: #393838; cursor: pointer; transition: color 0.2s;"
                  onmouseover="this.style.color='#1890ff'"
                  onmouseout="this.style.color='#393838'"
              >
                共{{comment.replyCount}}条回复，点击查看
              </button>
            </div>
            <div class="comment-content" style="line-height: 1.6; color: #393838;display: flex" v-else-if="comment.replyCount > 0">
              <button
                  @click="closeCommentReply(comment.id)"
                  style="border: none; background: none; padding: 0; margin: 0;font-size: 1.1rem; color: #393838; cursor: pointer; transition: color 0.2s;"
                  onmouseover="this.style.color='#1890ff'"
                  onmouseout="this.style.color='#393838'"
              >
                收起
              </button>
            </div>
            <!--回复列表-->
            <div class="reply-list" v-if="comment.showCommentReply">
              <div class="reply-item" v-for="reply in comment.children" :key="reply.id" style="border-top: #aeb0ba solid 0.05rem;">
                <div class="reply-content-container" style="display: flex; align-items: flex-start;">
                  <div class="avatar">
                    <img
                        :src="reply.avatar || defaultAvatar"
                        style="width: 2.5rem; height: 2.5rem; border-radius: 50%; object-fit: cover;"
                    >
                  </div>
                  <div style="margin-left: 0.8rem; display: flex;">
                      <span class="reply-author" style="font-size: 1.4rem;color: #737571;margin-right: 0.3rem">{{ reply.authorName }}</span>
                      <span class="reply-to" style="font-size: 1.4rem;color: #333;" v-if="reply.parentAuthor">回复</span>
                      <span class="reply-to-author" style="font-size: 1.4rem;color: #333;" v-if="reply.parentAuthor">@{{ reply.parentAuthor }}：</span>
                  </div>
                  <div class="comment-content">
                    <div style="font-size: 1.4rem; color: #333;">
                      {{ reply.content }}
                    </div>
                  </div>
                </div>
                <div style="margin-bottom: 1.5rem;margin-left: 3.3rem; color: #393838;display: flex">
                  <div style="font-size: 1.1rem;">{{reply.createTime}}</div>
                  <button
                      @click="showReplyInput(reply.id)"
                      style="border: none; background: none; padding: 0;margin: 0 0 0 1rem;font-size: 1.1rem; color: #393838; cursor: pointer; transition: color 0.2s;"
                      onmouseover="this.style.color='#1890ff'"
                      onmouseout="this.style.color='#393838'"
                  >
                    回复
                  </button>
                </div>
                <div class="reply-input" style="margin-top: 2rem" v-if="showReplyId === reply.id">
                  <el-input
                      type="textarea"
                      :placeholder="'回复@' + reply.authorName + '：'"
                      v-model="replyContent1"
                      :rows="2"
                  ></el-input>
                  <div class="reply-btn-group">
                    <el-button
                        type="primary"
                        size="mini"
                        style="margin-top: 1rem; margin-left: auto; display: block;"
                        :style="{backgroundColor: '#F32835',borderColor: '#F32835'}"
                        @click="submitReply1(reply.id,comment.id)"
                    >
                      回复
                    </el-button>
                  </div>
                </div>
              </div>
              <div style="display: flex;justify-content: center;width: 100%;">
                <el-pagination
                    background
                    @current-change="(val) => handleReplyCurrentChange(comment.id, val)"
                    @size-change="(val) => handleReplySizeChange(comment.id, val)"
                    :current-page.sync="comment.replyPageNum"
                    :page-size="comment.replyPageSize"
                    layout="prev, pager, next, total"
                    :total="comment.replyTotal"
                    style="text-align: center; margin-top: 1rem;font-size: 2rem">
                </el-pagination>
              </div>
            </div>
            <!--回复输入框 -->
            <div class="reply-input" style="margin-top: 2rem" v-if="showReplyId === comment.id">
              <el-input
                  type="textarea"
                  :placeholder="'回复@' + comment.authorName + '：'"
                  v-model="replyContent2"
                  :rows="2"
              ></el-input>
              <div class="reply-btn-group">
                <el-button
                    type="primary"
                    size="mini"
                    style="margin-top: 1rem; margin-left: auto; display: block"
                    :style="{backgroundColor: '#F32835',borderColor: '#F32835',}"
                    @click="submitReply2(comment.id)"
                >
                  回复
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 无评论提示 -->
      <div class="no-comment" v-else>
        暂无评论，快来发表你的观点吧~
      </div>
      <div style="display: flex;justify-content: center;width: 100%;">
        <el-pagination
            background
            @current-change="handleCommentCurrentChange"
            @size-change="handleCommentSizeChange"
            :current-page.sync="commentPageNum"
            :page-size="commentPageSize"
            layout="prev, pager, next, total"
            :total=commentPageTotal
            style="text-align: center; margin-top: 10rem;font-size: 2rem">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

import newService from "@/api/newService";
import {ArrowRight} from "@element-plus/icons-vue";

export default {
  name: "ForumOne",
  components: {ArrowRight},
    created() {

    },
    mounted() {
      this.getForumDetail()
      this.getComment();
    },
    data(){
    return {
      //分页参数
      commentPageNum: 1,
      commentPageSize: 10,
      commentPageCurrent: 1,
      commentPageTotal: 0,
      //默认头像
      defaultAvatar: '/favicon.ico',
      replyContent1:'',
      replyContent2:'',
      showReplyId:'',
      commentList:[],
      commentContent:'',
      postDetail:{
        title:'',
        authorName:'',
        createTime:'',
        viewCount:0,
        commentCount:0,
      }
    }
  },
  methods: {
    getComment(){
      newService.getCommentByPostIdToUser(localStorage.getItem('forumId'),this.commentPageNum,this.commentPageSize).then((res) => {
        const resStr = String(res);
        if (resStr.includes("错误^/^")) {
          //错误情况
          const parts = resStr.split(':');
          let errorMessage = '';
          if (parts.length >= 2) {
            errorMessage = parts.slice(1).join(':').trim();
          } else {
            errorMessage = resStr;
          }
          this.$message.error(errorMessage)
        }else {
          // 为每个评论初始化独立的分页参数
          this.commentList = res.records.map(comment => ({
            ...comment,
            showCommentReply: false,//回复弹层的开关
            replyPageNum: 1,       // 初始化当前页
            replyPageSize: 10,     // 初始化页大小
            replyTotal: 0,         // 初始化总条数
            children: comment.children || []  // 初始化回复列表
          }));
          this.commentPageTotal = res.total;
          this.commentPageCurrent = res.current;
        }
      })
    },
    async getReplyList(commentId){
      // 找到当前评论对象
      const comment = this.commentList.find(item => item.id === commentId);
      if (!comment) return;

      // 使用评论自身的分页参数请求数据
      await newService.getReplyByCommentIdToUser(
          commentId,
          comment.replyPageNum,  // 用当前评论的pageNum
          comment.replyPageSize  // 用当前评论的pageSize
      ).then((res) => {
        const resStr = String(res);
        if (resStr.includes("错误^/^")) {
          const parts = resStr.split(':');
          let errorMessage = '';
          if (parts.length >= 2) {
            errorMessage = parts.slice(1).join(':').trim();
          } else {
            errorMessage = resStr;
          }
          this.$message.error(errorMessage)
        }else {
          comment.children = res.records;
          comment.replyTotal = res.total;  // 更新当前评论的总条数
        }
      })

      // 打开弹层
      comment.showCommentReply = true;
    },
    closeCommentReply(commentId){
      // 找到当前评论对象
      const comment = this.commentList.find(item => item.id === commentId);
      if (!comment) return;
      //关闭弹层
      comment.showCommentReply = false;
    },
    submitComment(){
      if (this.commentContent.trim() === '' || !this.commentContent) {
        this.$message.info("您还没有评论");
        return;
      }
      const obj = {
        postId:localStorage.getItem('forumId'),
        content:this.commentContent,
        authorId:this?.$TOOL?.data?.get("USER_INFO")?.id ? this.$TOOL.data.get("USER_INFO").id : '',
        authorName:this?.$TOOL?.data?.get("USER_INFO")?.name ? this.$TOOL.data.get("USER_INFO").name : '游客',
        pid:'0',
        topId:'0'
      };
      this.commentContent = '';
      newService.saveCommentToUser(obj).then((res) => {
        const resStr = String(res);
        if (resStr.includes("错误^/^")) {
          const parts = resStr.split(':');
          let errorMessage = '';
          if (parts.length >= 2) {
            errorMessage = parts.slice(1).join(':').trim();
          } else {
            errorMessage = resStr;
          }
          this.$message.error(errorMessage)
        }else {
          //评论成功
          this.$message.success(resStr);
          this.getComment();
        }
      })
    },
    submitReply1(replyId,commentId){
      console.log("submitReply1",this.replyContent1);
      if (this.replyContent1 === '' || !this.replyContent1){
        this.$message.info("您还没有回复")
        return;
      }
      const obj = {
        postId:localStorage.getItem('forumId'),
        content:this.replyContent1,
        authorId:this?.$TOOL?.data?.get("USER_INFO")?.id ? this.$TOOL.data.get("USER_INFO").id : '',//目前没接入用户，用户id全都为空
        authorName:this?.$TOOL?.data?.get("USER_INFO")?.name ? this.$TOOL.data.get("USER_INFO").name : '游客',//用户名都为游客，后端会根据ip进行处理变成游客编号
        pid:replyId,
        topId:commentId
      };
      this.replyContent1 = '';
      newService.saveCommentToUser(obj).then(() => {
        this.$message.success("评论成功，等待管理员审核");
        this.getReplyList(commentId);
        this.showReplyId = '';
      })
    },
    submitReply2(commentId){
      console.log("submitReply2",this.replyContent2);
      if (this.replyContent2 === '' || !this.replyContent2){
        this.$message.info("您还没有回复")
        return;
      }
      const obj = {
        postId:localStorage.getItem('forumId'),
        content:this.replyContent2,
        authorId:this?.$TOOL?.data?.get("USER_INFO")?.id ? this.$TOOL.data.get("USER_INFO").id : '',
        authorName:this?.$TOOL?.data?.get("USER_INFO")?.name ? this.$TOOL.data.get("USER_INFO").name : '游客',
        pid:commentId,
        topId:commentId
      };
      this.replyContent2 = '';
      newService.saveCommentToUser(obj).then(() => {
        this.$message.success("评论成功，等待管理员审核");
        this.getReplyList(commentId);
        this.showReplyId = '';
      })
    },
    //打开回复框
    showReplyInput(commentId){
      if (this.showReplyId === commentId) {
        this.showReplyId = '';
      }else {
        this.replyContent1 = '';
        this.replyContent2 = '';
        this.showReplyId = commentId;
      }
    },
    getForumDetail(){
      const id = localStorage.getItem('forumId');
      newService.getForumByIdToUser(id).then((res) => {
        const resStr = String(res);
        if (resStr.includes("错误^/^")) {
          this.next();
          const parts = resStr.split(':');
          let errorMessage = '';
          if (parts.length >= 2) {
            errorMessage = parts.slice(1).join(':').trim();
          } else {
            errorMessage = resStr;
          }
          this.$message.error(errorMessage)
        }else {
          this.postDetail = res
        }
      })
    },
    index() {
      this.$store.state.components = 'home'
    },
    next() {
      this.$store.state.components = 'forum'
    },
    handleCommentCurrentChange(val) {
      this.commentPageNum=val;//当前页
      this.getComment();
    },
    handleCommentSizeChange(val) {
      this.commentPageSize=val;//当前页
      this.getComment();
    },
    // 回复分页当前页变化 - 接收评论ID
    handleReplyCurrentChange(commentId, val) {
      const comment = this.commentList.find(item => item.id === commentId);
      if (comment) {
        comment.replyPageNum = val;  // 更新对应评论的pageNum
        this.getReplyList(commentId);  // 重新加载该评论的回复
      }
    },
    // 回复分页页大小变化 - 接收评论ID
    handleReplySizeChange(commentId, val) {
      const comment = this.commentList.find(item => item.id === commentId);
      if (comment) {
        comment.replyPageSize = val;  // 更新对应评论的pageSize
        comment.replyPageNum = 1;     // 重置为第一页
        this.getReplyList(commentId);  // 重新加载该评论的回复
      }
    },
  }
}
</script>

<style lang="less" scoped>
/deep/.el-pagination.is-background .el-pager li:not(.disabled).is-active{
  background: #FFEDEF;border-radius: 6px;color: #FF0B41;
}
.forum-detail {
  padding-top: 6.6rem;
  //面包屑导航
  .linkbanner {
    position: relative;
    width: 118rem;
    height: 4.8rem;
    display: flex;
    align-items: center;
    margin: 0 auto;
    background: #f8f8f8;
    box-shadow: 0px 1px 0px 0px #e5e5e5;
    padding-left: 2rem;
    font-size: 1.6rem;

    .el-link--inner {
      font-size: 1.6rem;
    }

    .el-link.el-link--danger {
      color: #ed0200;
    }

    i {
      margin: 0 5px;
      font-size: 1.6rem;
    }
  }
  //居中布局
  .wrap {
    width: 120rem;
    margin: 0 auto;
    padding: 3rem 0;
  }

  .post-detail {
    .post-header {
      border-bottom: 1px solid #eee;
      padding-bottom: 2rem;
      margin-bottom: 2rem;

      h1 {
        font-size: 3rem;
        color: #333;
        margin-bottom: 1.5rem;
      }

      .post-info {
        display: flex;
        gap: 2rem;
        color: #999;
        font-size: 2rem;
      }
    }

    .post-content {
      padding: 2rem 0;
      font-size: 5rem;
      line-height: 1.8;
      color: #444;

      img {
        max-width: 100%;
        margin: 1rem 0;
      }
    }

    .comment-area {
      .comment-input {
        margin-bottom: 3rem;
        .el-textarea__inner {
          min-height: 100px;
          font-size: 1.4rem;
        }
      }

      .comment-list {
        .comment-item {
          .reply-input {
            margin: 1rem 0;
            padding: 1rem;
            background: #f9f9f9;
            border-radius: 4px;

            .el-textarea__inner {
              min-height: 80px;
              font-size: 1.3rem;
            }

            .reply-btn-group {
              display: flex;
              justify-content: flex-end;
              gap: 1rem;
              margin-top: 1rem;
            }
          }

          .reply-list {
            margin-top: 1rem;
            padding-left: 2rem;
            border-left: 2px solid #eee;

            .reply-item {
              display: flex;
              flex-wrap: wrap;
              gap: 0.5rem;
              margin-bottom: 1rem;
              font-size: 1.3rem;

              .reply-content {
                flex: 1;
              }

              .reply-time {
                width: 100%;
                color: #999;
                font-size: 1.2rem;
                margin-top: 0.5rem;
              }
            }
          }
        }
      }

      .no-comment {
        text-align: center;
        padding: 5rem 0;
        color: #999;
        font-size: 1.6rem;
        background: #f9f9f9;
        border-radius: 4px;
      }
    }
  }

}
</style>
